import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaCalendarAlt } from "react-icons/fa";

const IndianDatePickerWithIcon = ({ label, name, value, onChange }) => {
  const [startDate, setStartDate] = useState(value ? new Date(value) : null);
  const [inputValue, setInputValue] = useState("");
  const [showCalendar, setShowCalendar] = useState(false);

  // Format raw numbers into dd/mm/yyyy format
  const formatInput = (value) => {
    const numbers = value.replace(/\D/g, "");
    let formattedValue = "";

    if (numbers.length > 0) {
      formattedValue = numbers.substring(0, 2);
    }
    if (numbers.length > 2) {
      formattedValue += "/" + numbers.substring(2, 4);
    }
    if (numbers.length > 4) {
      formattedValue += "/" + numbers.substring(4, 8);
    }

    return formattedValue;
  };

  // Convert dd/mm/yyyy to Date object
  const parseInputToDate = (input) => {
    const parts = input.split("/");
    if (parts.length === 3 && parts[0].length === 2 && parts[1].length === 2 && parts[2].length === 4) {
      return new Date(`${parts[2]}-${parts[1]}-${parts[0]}`);
    }
    return null;
  };

  // Handle manual input changes
  const handleInputChange = (e) => {
    const rawValue = e.target.value;
    const formattedValue = formatInput(rawValue);
    setInputValue(formattedValue);

    // Update the date object if we have a complete date
    const date = parseInputToDate(formattedValue);
    if (date && !isNaN(date.getTime())) {
      setStartDate(date);
      const backendFormat = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
      onChange({ target: { name, value: backendFormat } });
    } else if (formattedValue === "") {
      onChange({ target: { name, value: "" } });
    }
  };

  // Handle calendar date selection
  const handleDateChange = (date) => {
    if (date) {
      const formattedDate = `${String(date.getDate()).padStart(2, "0")}/${String(date.getMonth() + 1).padStart(2, "0")}/${date.getFullYear()}`;
      setInputValue(formattedDate);
      setStartDate(date);
      onChange({
        target: {
          name,
          value: `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`
        }
      });
      setShowCalendar(false);
    }
  };

  // Initialize with the passed value
  useEffect(() => {
    if (value) {
      try {
        const date = new Date(value);
        if (!isNaN(date.getTime())) {
          const formattedDate = `${String(date.getDate()).padStart(2, "0")}/${String(date.getMonth() + 1).padStart(2, "0")}/${date.getFullYear()}`;
          setInputValue(formattedDate);
          setStartDate(date);
        }
      } catch {
        setInputValue("");
        setStartDate(null);
      }
    } else {
      setInputValue("");
      setStartDate(null);
    }
  }, [value]);

  return (
    <div style={{ position: "relative", marginTop: "7px" }}>
      <label
        style={{
          fontSize: "14px",
          marginBottom: "5px",
          display: "block",
          textAlign: "left",
          width: "100%",
          paddingLeft: "10px",
          color: "#374151",
        }}
      >
        {label}
      </label>
      <div style={{ display: "flex", alignItems: "center", marginLeft: "5px" }}>
        <input
          type="text"
          name={name}
          value={inputValue}
          onChange={handleInputChange}
          placeholder="DD/MM/YYYY"
          onFocus={() => setShowCalendar(true)}
          style={{
            paddingRight: "25px",
            fontSize: "14px",
            height: "45px",
            borderRadius: "5px",
            width: "350px",
            border: "1px solid #ccc",
          }}
        />
        <FaCalendarAlt
          style={{
            cursor: "pointer",
            position: "absolute",
            right: "10px",
            zIndex: 2,
            color: "#666",
          }}
          onClick={() => setShowCalendar(!showCalendar)}
        />
      </div>
      {showCalendar && (
        <div style={{
          position: "absolute",
          top: "100%",
          left: 0,
          zIndex: 10,
          backgroundColor: "white",
          boxShadow: "0 2px 5px rgba(0,0,0,0.2)"
        }}>
          <DatePicker
            selected={startDate}
            onChange={handleDateChange}
            dateFormat="dd/MM/yyyy"
            placeholderText="DD/MM/YYYY"
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            maxDate={new Date()}
            inline
          />
        </div>
      )}
    </div>
  );
};

export default IndianDatePickerWithIcon;
